/**
 * The lifecycle rule as a table (GH-800). Read by the unit test against `effectiveEventStatus`
 * and by the integration test against the SQL function `event_effective_status`, so the two
 * implementations are held to one list of answers rather than to two descriptions of it.
 *
 * Times are minutes relative to "now" (`AT`). `null` is "not stated".
 */
export const LIFECYCLE_AT = new Date("2026-10-01T18:00:00.000Z");
const minutes = (offset) => offset === null ? null : new Date(LIFECYCLE_AT.getTime() + offset * 60_000);
const make = (name, status, startsAt, endsAt, openedAt, expected) => ({
    name,
    facts: {
        status,
        startsAt: minutes(startsAt),
        endsAt: minutes(endsAt),
        openedAt: minutes(openedAt),
    },
    expected,
});
const DAY = 24 * 60;
export const EVENT_LIFECYCLE_CASES = [
    // Published: the clock decides.
    make("a future published event is upcoming, never live", "published", DAY, DAY + 120, null, "published"),
    make("a future published event with no end is upcoming", "published", 60, null, null, "published"),
    make("a published event that has started is live", "published", -30, 90, null, "live"),
    make("live exactly at the start", "published", 0, 90, null, "live"),
    make("a started event with no end stays live", "published", -DAY, null, null, "live"),
    make("a multi-day event between its days is live", "published", -DAY, DAY, null, "live"),
    make("past its end a published event is ended", "published", -180, -60, null, "ended"),
    make("ended exactly at the end", "published", -180, 0, null, "ended"),
    make("an undated published row (the general fund) is never live", "published", null, null, null, "published"),
    make("an undated published row past a stated end is ended", "published", null, -60, null, "ended"),
    // Live: an organizer opened it.
    make("started early is live before its start", "live", DAY, DAY + 120, 0, "live"),
    make("started early runs out at its stated end", "live", -60, -1, -120, "ended"),
    make("reopened after the stated end stays live", "live", -180, -60, -10, "live"),
    make("reopened after ending early ends at the stated end", "live", -180, -60, -120, "ended"),
    make("reopened after ending early is live before the end", "live", -60, 60, -10, "live"),
    make("opened with no end stays live until ended", "live", -DAY, null, -DAY, "live"),
    make("a legacy live row with no opened_at follows the end", "live", -180, -60, null, "ended"),
    make("a legacy live row with no opened_at and no end is live", "live", null, null, null, "live"),
    make("a legacy live row with no opened_at before its start is upcoming", "live", DAY, null, null, "published"),
    make("a legacy live row with no opened_at inside its window is live", "live", -60, 60, null, "live"),
    // Ended and the rest: what people decided.
    make("ended early is ended inside its window", "ended", -60, 60, null, "ended"),
    make("ended before it started is ended", "ended", DAY, DAY + 60, null, "ended"),
    make("archived is archived whatever the clock says", "archived", -60, 60, null, "archived"),
    make("a draft inside its window is still a draft", "draft", -60, 60, null, "draft"),
    make("reviewable is reviewable", "reviewable", -60, 60, null, "reviewable"),
    make("suspended is suspended", "suspended", -60, 60, -10, "suspended"),
];
//# sourceMappingURL=event-lifecycle-cases.js.map